import { render, staticRenderFns } from "./myPagination.vue?vue&type=template&id=5f3f1872&scoped=true&"
import script from "./myPagination.vue?vue&type=script&lang=js&"
export * from "./myPagination.vue?vue&type=script&lang=js&"
import style0 from "./myPagination.vue?vue&type=style&index=0&id=5f3f1872&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3f1872",
  null
  
)

export default component.exports